@if (settings.showUniquesTierListMessage()) {
  <div class="info box reset-font" style="margin-bottom: 12px;">
    <h3 class="info-title">Explainer: <strong>Chance Base Tier List</strong></h3>
    <div class="close-info-btn" (click)="hideInfoMessage()">✕</div>
    <div class="info-box-body">
      <app-content cid="explainer-chance-base-tier-list" contentType="tip" [conditions]="{ poe1: poe1, poe2: poe2 }"></app-content>
      <p>
        Bases you cannot use an <span class="currency-color">Orb of Chance</span> on and larger items are excluded. The 'Favourite' tier by default only lists the top 3 most valuable Base Types with only a single Unique{{ hardCodedChanceBases.length > 0 ? ' and the following Base Types: ' + hardCodedChanceBases + '.' : '.' }}
      </p>
      <p><a class="remove-warning-link" (click)="hideInfoMessage()">(I understand, dismiss)</a></p>
    </div>
  </div>
}

<div class="tier-list-info">
  <div class="tier-input">
    <input appGlobalShortcutFocus="f" placeholder="Search a Base Type or Unique" type="text" class="search-filter form-control"
      [(ngModel)]="uniqueFilter" (ngModelChange)="buildTierList()">
  </div>
</div>

<div class="tier-list">
  @for (tier of tierList; track tier.tier) {
    <div class="tier-column">
      <div class="tier"
            (dragenter)="onDragEnter($event, tier)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event, tier)"
            (drop)="onDrop($event, tier)"
            [class.drag-over]="tier.isDragOver">
        <app-tier-style [displayable]="tier.cosmetics" [allowedDisplayTypes]="[DisplayType.Custom]" [label]="tier.name" [allowHide]="false"
          [isHeader]="true" [isTitle]="true" [exampleName]="tier.exampleName" [styleDialogTitle]="tier.styleDialogTitle"></app-tier-style>
        @if (!filter.ssf) { <div class="tier-subtitle">{{ tier.price }}</div> }
        @if (tier.tier === 'Class') {
          <div class="unique-filter">
            <app-autocomplete
              [allLabel]="'None'"
              [options]="classes"
              [disabled]="false"
              [showOptions]="true"
              [selectedValues]="filter.showClassSpecificUniquesForClasses"
              (selectedValuesChange)="filter.showClassSpecificUniquesForClasses = $event; rebuildTierList();"></app-autocomplete>
          </div>
        }
        @if (tier.tier === 'Other' && (!uniqueFilter || uniqueFilter.length < 2) && !changedOnly) {
          <div class="tier-item-types">
            <div class="tier-item-type">
              <div class="tier-item-type-title"><h4>Search for Other Uniques</h4></div>
              <div class="extra-info tier-placeholder-text">
                Start typing in the search field above
                <br />to search through all other uniques.
              </div>
            </div>
          </div>
        }
        <div class="tier-item-types">
          @for (classGroup of (tier.tier === 'Other' ? filteredOtherBaseTypes : tier.classes); track classGroup.class) {
            <div class="tier-item-type">
              @if (classGroup.class !== 'Default') {
                <div class="tier-item-type-title"><h4>{{ classGroup.class }}</h4></div>
              }
              <div class="tier-item-type-body">
                @for (baseType of classGroup.items; track baseType.baseType) {
                  <div
                    draggable="true"
                    (dragstart)="onDragStart($event, baseType)"
                    (dragend)="onDragEnd()"
                    [class.dragged]="draggedItem?.baseType == baseType.baseType"
                    class="tier-item-type-base-type"
                  >
                    <span class="base-type-container">
                      <span class="base-type">{{ baseType.baseType }}</span>

                      @if (baseType.originalTier && baseType.originalTier !== tier.tier) {
                        <span class="original-tier" (click)="resetToOriginalTier(baseType)"
                          title="Reset to original {{ baseType.originalTier }}-tier">↻</span>
                      }

                      @if (tier.tier === 'Searching') {
                        <span class="move-item-link" (click)="moveToPotential(baseType)"
                          title="Move to Potential">
                          <span class="icon icon-star-empty"></span>
                        </span>
                      } @else {
                        <span class="move-item-link" (click)="moveToWanted(baseType)"
                          title="Move to Favourite">
                          <span class="icon icon-star-full"></span>
                        </span>
                      }
                    </span>

                    @for (unique of baseType.uniquesWithValuesAndImages; track unique.uniqueName) {
                      <div class="tier-item-type-unique">
                        <app-item-label
                          [unique]="true"
                          [baseType]="unique.uniqueName"
                          [image]="unique.image"
                          [hideTooltip]="draggedItem?.baseType == baseType.baseType"
                          [class.cheap-unique]="unique.value && unique.value < 10"
                        ></app-item-label>
                      </div>
                    }

                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
